import React from 'react';
export function ProblemSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-98" data-mp="14h4zv2xnw1xw">
      <div className="max-w-3xl mx-auto" data-id="element-99" data-mp="2lstjzhrrqcfl">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#F9327E]" data-id="element-100" data-mp="2ltw85hxpi0rt">
          NO TODOS LOS ALUMNOS APRENDEN DE LA MISMA MANERA
        </h2>

        <p className="text-lg mb-5 text-center text-gray-700" data-id="element-101" data-mp="2vpzcmug16bhx">
          Los materiales tradicionales suelen ser saturados, caóticos y poco
          accesibles.
        </p>

        <p className="text-lg md:text-xl text-center font-[800] text-[#3CD0E4]" data-id="element-102" data-mp="39jqjtw6ahjah">
          Pensado para acompañar alumnos con TDAH, TEA, Dislexia y distintos
          ritmos de aprendizaje.
        </p>
      </div>
    </section>;
}